import { useConnectedUser } from "components/ConnectedUserProvider"
import * as React from "react"
import { ObserverModal } from "components/ObserverModal"
import { RequireLogin } from "components/RequireLogin"

export const RequireClub = ({
  children,
  includeExClub = false,
  messages,
  actions,
}) => {
  const connectedUser = useConnectedUser()
  const [showConfirmModal, setShowConfirmModal] = React.useState(false)

  const handleNotClubInteraction = (e) => {
    if (e) {
      e.stopPropagation()
      e.preventDefault()
    }
    setShowConfirmModal(true)
  }

  const eventsToOverride = [
    children.props.href || children.props.onClick ? "onClick" : null,
    children.props.onSubmit ? "onSubmit" : null,
  ].filter(Boolean)

  const overridenProps = eventsToOverride.reduce((prev, current) => {
    prev[current] = handleNotClubInteraction

    return prev
  }, {})

  const rolesToCheck = [
    "ROLE_CLUB",
    includeExClub ? "ROLE_EX_CLUB" : null,
  ].filter(Boolean)

  const shouldShowModal = !rolesToCheck.some((role) =>
    connectedUser?.roles.includes(role),
  )

  if (!shouldShowModal) {
    return children
  }

  const props = { ...children.props, ...overridenProps }

  return (
    <>
      <RequireLogin>{React.cloneElement(children, props)}</RequireLogin>
      <ObserverModal
        isOpen={showConfirmModal}
        onRequestClose={() => setShowConfirmModal(false)}
        messages={messages}
        actions={actions}
      />
    </>
  )
}
